module.exports = __webpack_public_path__ + "static/media/55030.f2c428d6.jpg";